import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import Box from '../../../../shared/components/ui/Box';
import Button from '../../../../shared/components/ui/Button';
import FormControl from '../../../../shared/components/ui/FormControl';
import { useGetDeleteHandler } from '../../ReleasesForm/hooks/use-get-delete-handler/use-get-delete-handler.hook';
import { OuterExceptedAppReleasesFormProps } from '../models/outer-excepted-app-releases-form.props';
import { ExceptedAppsReleaseFormProps } from '../types/excepted-apps-release-form-props.type';

export const ReleaseActionButtons: FunctionComponent<
  OuterExceptedAppReleasesFormProps & ExceptedAppsReleaseFormProps
> = (
  props: PropsWithChildren<
    OuterExceptedAppReleasesFormProps & ExceptedAppsReleaseFormProps
  >
) => {
  const { data, isFormOpen, cancelAction, parsedAppId } = props;
  const deleteActionHandler = useGetDeleteHandler(parsedAppId, data);

  return (
    <FormControl
      classes={{
        root: 'button-container',
      }}
    >
      <Box
        sx={{
          flexWrap: 'wrap',
          display: 'flex',
          gap: '24px',
        }}
      >
        {data && (
          <Button
            type="button"
            variant="contained"
            classes={{
              root: 'button',
            }}
            className="btn btn-white"
            onClick={deleteActionHandler}
          >
            Delete
          </Button>
        )}

        {isFormOpen && (
          <Button
            type="button"
            variant="contained"
            classes={{
              root: 'button',
            }}
            className="btn btn-white"
            onClick={cancelAction}
          >
            Cancel
          </Button>
        )}

        <Button
          type="submit"
          variant="contained"
          classes={{
            root: 'button',
          }}
          className="btn btn-primary"
        >
          Save
        </Button>
      </Box>
    </FormControl>
  );
};
